import { useCallback, useState } from 'react';

export const useShippingSelector = () => {
  const [isShippingSelectorVisible, setIsShippingSelectorVisible] = useState(false);
  const changeShippingVisibility = useCallback(() => setIsShippingSelectorVisible(!isShippingSelectorVisible), [
    isShippingSelectorVisible,
  ]);

  return {
    changeShippingVisibility,
    isShippingSelectorVisible,
  };
};
